<ng-template #sectionContentBlocks>
  @if(!!section?.title){<div [innerHTML]="sectionTitle"></div>}
  @if(!!section?.subtitle){<p class="font-medium text-md">{{ section.subtitle }}</p>}
  @if(section?.body?.content[0]?.content){<p [innerHTML]="sectionBody"></p>}

  @for (block of section.blocks; track $index) {
  @switch (block.component) {
  @case ('embed') {<app-cms-embed [embed]="block"></app-cms-embed>}
  @case ('accordeon') {<app-cms-accordeon [accordeon]="block"></app-cms-accordeon>}
  @case ('CTA') {<app-cms-button [button]="block"></app-cms-button>}
  @case ('sticker') { <app-cms-sticker [sticker]="block" [moveUp]="!!section.title?.content[0]?.content"></app-cms-sticker>}
  @case ('stack') {<app-cms-stack [stack]="block"></app-cms-stack>}
  @case ('feedbackwidget') {<app-cms-feedbackwidget [feedbackwidget]="block"></app-cms-feedbackwidget>}
  @case ('tellafriend') {<app-cms-tellafriend [tellafriend]="block"></app-cms-tellafriend>}
  @case ('section') {<app-cms-section [section]="block" [index]="(index + 1)"></app-cms-section>}
  }
  }
</ng-template>

<ng-template #sectionImageBlock>
  <div class="flex rounded-3xl overflow-hidden min-h-[300px] h-full" [ngClass]="section.main_image_contain ? 'bg-' + section.main_image_bgcolor : ''">
    @if(section?.imagereplacement_blocks?.length >0){
    <div class="flex flex-row justify-center w-full my-auto">
      @for (block of section?.imagereplacement_blocks; track $index) {
      @switch (block.component) {
      @case ('feedbackwidget') {<app-cms-feedbackwidget [feedbackwidget]="block"></app-cms-feedbackwidget> }
      }
      }
    </div>
    } @else {
    <app-cms-image imageClass="max-h-[600px] {{section.main_image_contain ? 'm-auto' : 'object-cover w-full h-full rounded-3xl'}}" [height]="600" [image]="section.main_image"
      [contain]="section.main_image_contain" [loadEager]="index === 0"></app-cms-image>
    }
  </div>
  @if(!!section.sticker?.filename){
  <img class="absolute top-[50px] left-[25px] h-[100px] w-[100px] md:top-[75px] md:left-[50px] md:h-[150px] md:w-[150px]" height="150" width="150" [alt]="get_alt(section.sticker)"
    [src]="get_src(section.sticker,false, 150)" [attr.loading]="index === 0 ? 'eager' : 'lazy'" />
  }
  @if(section?.layout === 'IMG_HERO'){
  <div class="flex justify-center md:hidden">
    <div class="icon-round relative top-[-20px]"><img alt="arrow-down" class="h-5 w-5" height="20" width="20" src="./assets/images/icons/arrow_down.svg" /></div>
  </div>
  }
</ng-template>

<ng-template #sectionImageBlockAfbbeelding>
  <div class="flex rounded-[0.625rem] overflow-hidden h-full" [ngClass]="section.main_image_contain ? 'bg-' + section.main_image_bgcolor : ''">
    @if(section?.imagereplacement_blocks?.length >0){
    <div class="flex flex-row justify-center w-full my-auto">
      @for (block of section?.imagereplacement_blocks; track $index) {
      @switch (block.component) {
      @case ('feedbackwidget') {<app-cms-feedbackwidget [feedbackwidget]="block"></app-cms-feedbackwidget> }
      }
      }
    </div>
    } @else {
    <app-cms-image imageClass="max-h-[600px] {{section.main_image_contain ? 'm-auto' : 'object-cover w-full md:h-full  rounded-[0.625rem]'}}" [height]="600"
      [image]="section.main_image" [contain]="section.main_image_contain" [loadEager]="index === 0"></app-cms-image>
    }
  </div>
  @if(!!section.sticker?.filename){
  <img class="absolute top-[50px] left-[25px] h-[100px] w-[100px] md:top-[75px] md:left-[50px] md:h-[150px] md:w-[150px]" height="150" width="150" [alt]="get_alt(section.sticker)"
    [src]="get_src(section.sticker,false, 150)" [attr.loading]="index === 0 ? 'eager' : 'lazy'" />
  }
  @if(section?.layout === 'IMG_HERO'){
  <div class="flex justify-center md:hidden">
    <div class="icon-round relative top-[-20px]"><img alt="arrow-down" class="h-5 w-5" height="20" width="20" src="./assets/images/icons/arrow_down.svg" /></div>
  </div>
  }
</ng-template>


@if(section?.layout && !section?.hidden){
@if (section.layout === 'IMGONLY') {
<div class="container-default mt-[-50px]">
  <app-cms-image imageClass="max-h-[750px] w-full h-full object-cover rounded-xl" [height]="800" [image]="section.main_image" [contain]="false"
    [loadEager]="index === 0"></app-cms-image>
</div>
} @else if (section?.layout === 'HERO') {
<div class="hero-section relative h-[39rem] md:h-[43.75rem] mt-[0.625rem] flex flex-col text-white">
  <app-cms-image imageClass="max-h-[700px] object-cover w-full h-full z-[1] absolute top-0 left-0" [height]="700" [image]="section.main_image"
    [contain]="section.main_image_contain" [loadEager]="index === 0"></app-cms-image>
  <div class="relative flex-grow flex flex-col justify-between w-full px-[1rem] sm:px-[2rem] max-w-[90rem] mx-auto z-[2]">
    @if(!!section.sticker?.filename){
    <div class="pt-[1rem] md:pt-[3.5rem]">
      <img class="size-[5rem] md:size-[7.875rem]" height="150" width="150" [alt]="get_alt(section.sticker)" [src]="get_src(section.sticker,false, 150)"
        [attr.loading]="index === 0 ? 'eager' : 'lazy'" />
    </div>
    }
    <div class="hero-section-content pb-[2.75rem] flex flex-col flex-grow">
      <ng-container *ngTemplateOutlet="sectionContentBlocks"></ng-container>
    </div>
    @if(!!section.sticker_bottom?.filename){
    <div class="md:max-w-[4.3125rem] max-w-[2.3125rem] absolute md:bottom-[2rem] bottom-[1rem] md:right-[2.5rem] right-[1rem]">
      <img height="46" width="69" [alt]="get_alt(section.sticker_bottom)" [src]="get_src(section.sticker_bottom,false, 69)" [attr.loading]="index === 0 ? 'eager' : 'lazy'" />
    </div>
    }
  </div>
</div>
}@else{
<div class="relative" [ngClass]="[  get_classes(section),   section.condensed ? 'py-[15px] md:p-[50px]' : 'p-[50px] lg:p-[100px]',  inPopup? 'px-[5px]': 'px-6']">
  @if(section?.layout.includes('IMG_')){
  <div class="relative flex flex-col justify-between w-full max-w-[1428px] mx-auto" [ngClass]="get_direction(section)">
    <div class="flex flex-col flex-grow justify-center mt-6 md:mt-0" [ngClass]="section?.layout !== 'IMG_HERO' ? 'md:w-1/2' : 'md:w-1/3'">
      <ng-container *ngTemplateOutlet="sectionContentBlocks"></ng-container>
    </div>
    <div class="md:w-[150px]"></div>
    <div class="pt-6 relative" [ngClass]="section?.layout === 'IMG_HERO' ? 'md:w-2/3 md:min-h-[500px]' : 'md:w-1/2'">
      <ng-container *ngTemplateOutlet="sectionImageBlock"></ng-container>
    </div>
  </div>
  }

  @if(section?.layout.includes('AFBEELDING')){
  <div class="afbeelding-section relative flex flex-col justify-between w-full max-w-[90rem] mx-auto gap-[2.4rem] md:gap-0" [ngClass]="get_direction(section)">
    <div class="flex flex-col flex-grow justify-center md:w-1/2 order-2 md:order-none md:px-[2rem] lg:px-[3rem] xl:px-[4rem] gap-[1rem]">
      <ng-container *ngTemplateOutlet="sectionContentBlocks"></ng-container>
    </div>
    <div class="relative md:w-1/2 order-1 md:order-none">
      <ng-container *ngTemplateOutlet="sectionImageBlockAfbbeelding"></ng-container>
    </div>
  </div>
  }
  <!-- TEXT ONLY -->
  @if(section?.layout.includes('TEXT')){
  <div class="text-section relative sm:text-left md:text-center max-w-[1428px] mx-auto" [ngClass]="section.width">
    <div [ngClass]="section.cols === '2' ? 'md:grid md:grid-cols-2 gap-6' : ''">
      @if(!!section.main_image?.filename){
      <app-cms-image imageClass="mx-auto mb-6 md:mb-[50px] rounded-lg max-w-[200px]" [width]="200" [image]="section.main_image" [contain]="false"
        [loadEager]="index === 0"></app-cms-image>
      }

      @if(!!section?.title){<div [innerHTML]="sectionTitle"></div>}
      @if(!!section?.subtitle){<p class="font-medium text-md">{{ section.subtitle }}</p>}
      @if(section?.body?.content[0]?.content){<p [innerHTML]="sectionBody"></p>}

      @for (block of section.blocks; track $index) {
      @switch (block.component) {
      @case ('embed') {<app-cms-embed [embed]="block"></app-cms-embed>}
      @case ('accordeon') {<app-cms-accordeon [accordeon]="block"></app-cms-accordeon>}
      @case ('CTA') {<app-cms-button [button]="block"></app-cms-button>}
      @case ('sticker') { <app-cms-sticker [sticker]="block" [moveUp]="!!section.title?.content[0]?.content"></app-cms-sticker>}
      @case ('stack') {<app-cms-stack [stack]="block"></app-cms-stack>}
      @case ('card') { <app-cms-card [card]="block"></app-cms-card>}
      @case ('RecipeCards') {<app-cms-recipe-cards [card]="block" class="block mb-6"></app-cms-recipe-cards>}
      @case ('LifestyleCards') {<app-cms-lifestyle-cards [card]="block"></app-cms-lifestyle-cards>}
      @case ('slider') {<div class="relative"><app-cms-swiper [slider]="block"></app-cms-swiper></div>}
      @case ('section') {<div class="mt-10 md:mt-[90px]"><app-cms-section [section]="block" [index]="(index + 1)"></app-cms-section></div>}
      @case ('feedbackwidget') {<app-cms-feedbackwidget [feedbackwidget]="block"></app-cms-feedbackwidget> }
      @case ('tellafriend') {<app-cms-tellafriend [tellafriend]="block"></app-cms-tellafriend>}
      @case ('weekFavorites') {<app-cms-week-favorites [block]="block"></app-cms-week-favorites>}
      @case ('textBlock') {<app-cms-text-block [block]="block"></app-cms-text-block>}
      }
      }
    </div>
  </div>
  }
</div>
}
}